import { RESET_STUDIO_ACTION } from '../consts';
import type { StudioSplitTestingActions } from '../../actions/studio/split-testing';

export interface State {
    isProvisioningContainer: boolean;
    isCheckingEnvChanges: boolean;
    hasChangesOnEnvironments: boolean;
    provisioningTest: boolean;
    provisioningTestFailed: boolean;
    startingTest: boolean;
    startingTestFailed: boolean;
    finishingSplitTest: boolean;
    finishingSplitTestFailed: boolean;
    cleaningUpSplitTest: boolean;
    cleaningUpSplitTestFailed: boolean;
}

const getDefaultState = (): State => ({
    isProvisioningContainer: false,
    isCheckingEnvChanges: false,
    hasChangesOnEnvironments: false,
    provisioningTest: false,
    provisioningTestFailed: false,
    startingTest: false,
    startingTestFailed: false,
    finishingSplitTest: false,
    finishingSplitTestFailed: false,
    cleaningUpSplitTest: false,
    cleaningUpSplitTestFailed: false
});

const studioSplitTestingReducer = (state = getDefaultState(), action: StudioSplitTestingActions | null): State => {
    switch (action?.type) {
        case 'SET_STUDIO_SPLIT_TESTING_PROVISIONING_CONTAINER': {
            return {
                ...state,
                isProvisioningContainer: action.data.isProvisioningContainer
            };
        }

        case 'SET_STUDIO_SPLIT_TESTING_CHECKING_ENV_CHANGES': {
            return {
                ...state,
                isCheckingEnvChanges: action.data.isCheckingEnvChanges
            };
        }

        case 'SET_STUDIO_SPLIT_TESTING_HAS_CHANGES_ON_ENV': {
            return {
                ...state,
                hasChangesOnEnvironments: action.data.hasChanges
            };
        }

        case 'SET_STUDIO_SPLIT_TEST_STATUS': {
            const newState: Partial<State> = {};
            if (action.data.runningKey) {
                newState[action.data.runningKey] = action.data.runningValue;
            }
            if (action.data.failingKey) {
                newState[action.data.failingKey] = action.data.failingValue;
            }
            return {
                ...state,
                ...newState
            };
        }

        case RESET_STUDIO_ACTION: {
            return getDefaultState();
        }

        default: {
            return state;
        }
    }
};

export default studioSplitTestingReducer;
